export default function TeamMemberCard({
  image,
  name,
  description1,
  description2,
}) {
  return (
    <div className="group relative w-72 h-full mx-auto">
      {/* Main card container with fixed height and width */}
      <div className="bg-white shadow-xl rounded-3xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl h-full flex flex-col w-full">
        {/* Image container - fixed height */}
        <div className="relative overflow-hidden flex-shrink-0">
          <img
            src={
              image || "https://via.placeholder.com/400x500?text=Team+Member"
            }
            alt={name}
            className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
          />
          {/* Gradient overlay on hover */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>

        {/* Content card - positioned to overlap image and fill remaining space */}
        <div className="relative -mt-12 mx-4 mb-4 flex-grow flex flex-col">
          <div className="bg-white rounded-2xl shadow-2xl p-4 transform transition-all duration-300 group-hover:bg-gradient-to-br group-hover:from-blue-600 group-hover:to-purple-600 group-hover:text-white border border-gray-100 flex-grow flex flex-col justify-between min-h-[160px]">
            {/* Name - fixed at top */}
            <div>
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-white transition-colors duration-300 mb-3 text-center line-clamp-2 leading-tight">
                {name || "Team Member"}
              </h3>
            </div>

            {/* Descriptions - flexibly spaced */}
            <div className="space-y-2 flex-grow flex flex-col justify-center">
              <p className="text-xs font-semibold text-blue-600 group-hover:text-blue-100 transition-colors duration-300 text-center uppercase tracking-wide line-clamp-3 leading-tight">
                {description1 || "Primary Role"}
              </p>

              {/* Divider */}
              <div className="w-8 h-0.5 bg-gray-300 group-hover:bg-white/30 mx-auto transition-colors duration-300 my-2"></div>

              {/* Secondary description */}
              <p className="text-xs text-gray-600 group-hover:text-gray-200 transition-colors duration-300 text-center leading-relaxed line-clamp-2">
                {description2 || "Secondary description"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
